import api from './axiosInterceptors';
import { API_ENDPOINTS } from './apiEndpoints';

export type APIBreakdown = {
  api_name: string;
  total: number;
  success: number;
  failure: number;
  status_codes: Record<string, number>;
};

export type BreakdownResponse = {
  items: APIBreakdown[];
};

export type VendorsResponse = {
  vendors: string[];
};

export type BreakdownParams = {
  from: string;
  to: string;
  vendor?: string;
  api_name?: string;
  status_code?: string;
};

export async function listVendors(): Promise<string[]> {
  const { data } = await api.get<VendorsResponse>(API_ENDPOINTS.vendors);
  return data.vendors ?? [];
}

export async function getBreakdown(
  params: BreakdownParams,
): Promise<APIBreakdown[]> {
  const { data } = await api.get<BreakdownResponse>(API_ENDPOINTS.breakdown, {
    params: {
      from: params.from,
      to: params.to,
      ...(params.vendor ? { vendor: params.vendor } : {}),
      ...(params.api_name ? { api_name: params.api_name } : {}),
      ...(params.status_code ? { status_code: params.status_code } : {}),
    },
  });
  return data.items ?? [];
}
